package com.narbase.narnic.trial.utils.popup

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2020/08/18.
 */
object PopupZIndex {
    private var index = 350
    fun getTopIndex(): Int {
        return index++
    }

    fun restoreTopIndex() {
    }

    fun setMinTopIndex(newIndex: Int) {
        index = maxOf(newIndex + 1, index)
    }


    private val displayedDialogsStack = ArrayDeque<String>()
    fun addToStack(dialogId: String) = displayedDialogsStack.addFirst(dialogId)
    fun removeFromStack(dialogId: String) = displayedDialogsStack.remove(dialogId)
    fun isAtTheTop(dialogId: String) = displayedDialogsStack.firstOrNull() == dialogId

}